import { gsap } from '../global/gsap';

const initAnnouncement = (el) => {
    const mm = gsap.matchMedia();

    mm.add('(min-width: 901px)', () => {
        if (el) {
            gsap.to(el, {
                scrollTrigger: {
                    trigger: el,
                    end: 400,
                    invalidateOnRefresh: true,
                    scrub: 1,
                    onEnter: () => {
                        el.classList.add('is-shown');
                    },
                    onLeave: () => {
                        el.classList.remove('is-shown');
                    },
                    onEnterBack: () => {
                        el.classList.add('is-shown');
                    },
                },
            });
        }
    });
};

export default initAnnouncement;
